import { useEffect, useState } from "react"
import { Alert } from '@components'
import { getMinutesSecondsText } from "@helpers"
import { Button } from '@heroui/react'
import dayjs from "dayjs"
import PropTypes from "prop-types"

const AppointmentCountdownAlert = ({ appointment, handleGoToAppointment }) => {
  const [countdownMessage, setCountdownMessage] = useState(null);

  const getDurationToAppointment = () => {
    const secondsToAppointmentStarts = appointment.starts_at.diff(dayjs(), "seconds");
    const secondsToAppointmentEnds = appointment.ends_at.diff(dayjs(), "seconds")

    if (secondsToAppointmentStarts === 0 && secondsToAppointmentEnds > 0) {
      return "Appointment is starting now"
    }
    
    if (secondsToAppointmentEnds < 0) {
      return "Appointment has expired"
    }

    // Meeting has started
    if (secondsToAppointmentStarts < 0 && secondsToAppointmentEnds > 0) {
      const duration = dayjs.duration(secondsToAppointmentStarts, "seconds").humanize(true)

      return (
        <span>
          Your appointment with <strong>{appointment.parent}</strong> started <strong>{duration}</strong>.
        </span>
      )
    }

    // Meeting starts in less than 5 minutes
    if (secondsToAppointmentStarts < 300) {
      const minutes = Math.floor(secondsToAppointmentStarts / 60)
      const seconds = secondsToAppointmentStarts % 60
      const duration = getMinutesSecondsText(minutes, seconds)

      return (
        <span>
          Your next appointment with <strong>{appointment.parent}</strong> starts in <strong>{duration}</strong>.
        </span>
      ) 
    } 
    
    // Meeting starts in more than 5 minutes
    const duration = dayjs.duration(secondsToAppointmentStarts, "seconds").humanize(true)
    
    return (
      <span>
        Your next appointment with <strong>{appointment.parent}</strong> is starting in <strong>{duration}</strong>.
      </span>
    )    
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdownMessage(getDurationToAppointment());
    }, 1000); // Runs every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [appointment]); // eslint-disable-line react-hooks/exhaustive-deps
             
  if (!countdownMessage) return null
  
  return (
    <Alert
      classNames="mb-1 px-4 py-2"
      description={countdownMessage}
      rightContent={<Button className='text-white bg-blue-800 dark:bg-content3' onPress={() => handleGoToAppointment()}>Go to Meeting</Button>}
      title="Next Meeting"
      type="info"
    />
  )
}

AppointmentCountdownAlert.propTypes = {
  appointment: PropTypes.shape({
    parent: PropTypes.string.isRequired,
    starts_at: PropTypes.object.isRequired,
    ends_at: PropTypes.object.isRequired
  }).isRequired,
  
  handleGoToAppointment: PropTypes.func.isRequired
}
  
export default AppointmentCountdownAlert